// Device px, not the print-oriented units in clockDimensions.ts. These mirror
// the clock app's Pendulum.kt geometry (BOB_RADIUS = 205 -> diameter 410) so the
// Studio preview matches the physical device 1:1.
export const PENDULUM_BOB_DIAMETER_PX = 410;
export const PENDULUM_LOGO_SIZE_MIN = 200;
// Mirrors PENDULUM_LOGO_SIZE_MAX in klydo-api and PENDULUM_LOGO_MAX_DIAMETER
// in the clock app's Pendulum.kt. NOT itself what keeps the logo inside the
// round bob: the largest square that avoids the edge on its own is
// BOB_RADIUS*2/sqrt(2) ~= 290, well under 380. The overflow:hidden clip on
// the ball (Pendulum.tsx) and clipPath in the clock app do the actual work -
// 380 is a product-chosen ceiling, not a geometric guarantee.
export const PENDULUM_LOGO_SIZE_MAX = 380;

// Mirrors PENDULUM_LOGO_SIZE_LEGACY_DEFAULT in klydo-api - the size every
// clock drew before this feature existed, used as the fallback for a
// collection that has never had a size chosen.
export const PENDULUM_LOGO_SIZE_LEGACY_DEFAULT = 200;

// Mirrors PendulumLogoType in klydo-api's DraftCollection (TK-688):
// 'sized' (default) pads logoUrl to pendulumLogoSize on the bob; 'full'
// (B2B-only, rejected server-side otherwise) bakes logoUrl to cover-crop the
// entire bob instead, ignoring pendulumLogoSize.
export type PendulumLogoType = 'sized' | 'full';
export const PENDULUM_LOGO_TYPE_DEFAULT: PendulumLogoType = 'sized';
